import styled from '@emotion/styled';
import { TimingSystems } from '@racemap/utilities/consts/events';
import { TimingSystemLabels } from '@racemap/utilities/consts/events';
import type { FC } from 'react';
import { useCurrentEvent } from 'src/lib/customHooks/useCurrentEvent';
import { useEventFieldGenerator } from 'src/lib/customHooks/useEventFieldGenerator';
import { FormSelect } from '../FormComponents';
import {
  ChronoTrackConfiguration,
  DefaultTimingSystemConfiguration,
  FeibotConfiguration,
  MyLapsConfiguration,
  NoConfiguration,
  RaceresultConfiguration,
} from './ConfigurationModules';

const ConfigurationModules = {
  [TimingSystems.RACERESULT]: RaceresultConfiguration,
  [TimingSystems.CHRONO_TRACK]: ChronoTrackConfiguration,
  [TimingSystems.MY_LAPS]: MyLapsConfiguration,
  [TimingSystems.FEIBOT]: FeibotConfiguration,
  [TimingSystems.OTHER]: DefaultTimingSystemConfiguration,
  [TimingSystems.NONE]: NoConfiguration,
};

export const TimingSystemConfiguration: FC = () => {
  const event = useCurrentEvent();
  if (event == null) return <></>;

  const fieldGenerator = useEventFieldGenerator(event);
  if (fieldGenerator == null) return <></>;

  const timingsystem = event.modules.predictive.timingsystem;
  const TimingSystemSpecificModule =
    ConfigurationModules[timingsystem] ?? DefaultTimingSystemConfiguration;

  const { value, onChange } = fieldGenerator('modules.predictive.timingsystem');

  const chooser = (
    <div style={{ marginTop: '10px', width: '100%' }}>
      <FormSelect
        id="timingsystem_input"
        required
        value={value === TimingSystems.NONE ? undefined : value}
        onChange={(timingSystem: TimingSystems | null) => {
          console.log('timingsystem changed', timingSystem);
          onChange(timingSystem == null ? TimingSystems.NONE : timingSystem);
        }}
        allowClear
      >
        {Object.values(TimingSystems)
          .filter((ts) => ts !== TimingSystems.NONE)
          .map((tS) => (
            <option value={tS} key={tS}>
              {TimingSystemLabels[tS]}
            </option>
          ))}
      </FormSelect>
    </div>
  );

  return (
    <Container>
      <div
        style={{
          width: '300px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          whiteSpace: 'nowrap',
        }}
      >
        <b>Timing System:</b>
        {chooser}
      </div>
      <TimingSystemSpecificModule />
    </Container>
  );
};

const Container = styled.div`
  .bordered-box {
    margin-bottom: 20px;
    padding: 15px;
  }
`;
